import { CommonModule } from '@angular/common';
import { isPlatformBrowser } from '@angular/common';
import { Inject, Injector, NgModule, PLATFORM_ID } from '@angular/core';
import { createCustomElement } from '@angular/elements';
import {
  ButtonModule,
  CheckboxModule,
  FormModule,
  InputModule
} from '@apps/ui';
import { InitialFormModule } from '@stop-counter/shared/components/initial-form/initial-form.module';
import { SharedModule } from '@stop-counter/shared/shared.module';
// Komponenty widgetow embed (stop-counter, sc-zipcode) wkompilowane w build
// aplikacji zamiast ladowania /embed/*.js z zewnetrznego serwera widgetow.
// Import relatywny miedzy appkami Nx - te appki i tak wspoldziela caly kod
// przez @stop-counter/shared/* (mapowane na _shared tej aplikacji).
import { AppComponent as StopCounterWidgetComponent } from '../../../../../../stop-counter-widget/src/app/app.component';
import { AppComponent as ZipCodeWidgetComponent } from '../../../../../../stop-counter-zip-code-widget/src/app/app.component';

const ELEMENTS: [string, any][] = [
  ['stop-counter', StopCounterWidgetComponent],
  ['sc-zipcode', ZipCodeWidgetComponent]
];

@NgModule({
  declarations: [StopCounterWidgetComponent, ZipCodeWidgetComponent],
  imports: [
    CommonModule,
    FormModule,
    ButtonModule,
    CheckboxModule,
    InputModule,
    InitialFormModule,
    SharedModule
  ],
  entryComponents: [StopCounterWidgetComponent, ZipCodeWidgetComponent]
})
export class WidgetElementsModule {
  constructor(injector: Injector, @Inject(PLATFORM_ID) platformId: Object) {
    // Custom elements istnieja tylko w przegladarce; SSR renderuje tagi
    // jako nieznane elementy (jak dotad przy ladowaniu z /embed).
    if (!isPlatformBrowser(platformId)) {
      return;
    }

    ELEMENTS.forEach(([name, component]) => {
      if (!customElements.get(name)) {
        customElements.define(
          name,
          createCustomElement(component, { injector })
        );
      }
    });
  }
}
